<template>
  <div class="page-parts-panel-text">
    <div class="parts-container">
      <div class="_panel-text-area">
        <div v-if="title" class="_top">
          <div
            class="_content"
            :style="{ background: bgColorRef(panel1BgColor), color: textColorRef(panel1TextColor) }"
          >
            <h3
              class="_title"
              :class="[fontSize, titleFontWeight, { 'page-parts-pc': !!spTitle }]"
              v-html="sanitizeHtmlContent(title)"
            ></h3>
            <h3
              v-if="spTitle"
              class="_title page-parts-sp"
              :class="[fontSize, titleFontWeight]"
              v-html="sanitizeHtmlContent(spTitle)"
            ></h3>
            <p
              class="_description"
              :class="[descFontSize, { 'page-parts-pc': !!spDescription }]"
              v-html="sanitizeHtmlContent(description)"
            ></p>
            <p
              v-if="spDescription"
              class="_description page-parts-sp"
              :class="[descFontSize]"
              v-html="sanitizeHtmlContent(spDescription)"
            ></p>
          </div>
        </div>
        <div
          v-if="panel2Text1 || panel2Text2 || panel2Emphasis"
          class="_bottom"
          :style="{ background: bgColorRef(panel2BgColor), color: textColorRef(panel2TextColor) }"
        >
          <div class="_content">
            <p
              class="_top-text _text"
              :class="[descFontSize, { 'page-parts-pc': !!spPanel2Text1 }]"
              v-html="sanitizeHtmlContent(panel2Text1)"
            ></p>
            <p
              v-if="spPanel2Text1"
              class="_top-text _text page-parts-sp"
              :class="[descFontSize]"
              v-html="sanitizeHtmlContent(spPanel2Text1)"
            ></p>
            <p
              class="_emphasis"
              :class="[emphasisFontSize, emphasisFontWeight, { 'page-parts-pc': !!spPanel2Emphasis }]"
              v-html="sanitizeHtmlContent(panel2Emphasis)"
            ></p>
            <p
              v-if="spPanel2Emphasis"
              class="_emphasis _text page-parts-sp"
              :class="[emphasisFontSize, emphasisFontWeight]"
              v-html="sanitizeHtmlContent(spPanel2Emphasis)"
            ></p>
            <p
              class="_bottom-text _text"
              :class="[descFontSize, { 'page-parts-pc': !!spPanel2Text2 }]"
              v-html="sanitizeHtmlContent(panel2Text2)"
            ></p>
            <p
              v-if="spPanel2Text2"
              class="_bottom-text _text page-parts-sp"
              :class="[descFontSize]"
              v-html="sanitizeHtmlContent(spPanel2Text2)"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { sanitizeHtmlContent } from "@tential/ec-gql-schema/utils/functions/sanitize"

type Props = {
  title: string
  spTitle?: string
  description?: string
  spDescription?: string
  fontSize?: string[]
  descFontSize?: string[]
  titleFontWeight?: string
  panel1TextColor?: string
  panel1BgColor?: string
  panel2BgColor?: string
  panel2Text1?: string
  spPanel2Text1?: string
  panel2Emphasis?: string
  spPanel2Emphasis?: string
  emphasisFontSize?: string[]
  emphasisFontWeight?: string
  panel2Text2?: string
  spPanel2Text2?: string
  panel2TextColor?: string
}

withDefaults(defineProps<Props>(), {
  title: "",
  spTitle: "",
  description: "",
  spDescription: "",
  fontSize: () => [],
  descFontSize: () => [],
  titleFontWeight: "",
  panel1TextColor: "#fff",
  panel1BgColor: "",
  panel2BgColor: "#eff0f4",
  panel2Text1: "",
  spPanel2Text1: "",
  panel2Emphasis: "",
  spPanel2Emphasis: "",
  emphasisFontSize: () => [],
  emphasisFontWeight: "",
  panel2Text2: "",
  spPanel2Text2: "",
  panel2TextColor: "#000",
})

const bgColorRef = (inputColor: string): string => {
  return inputColor || "#284b7d"
}

const textColorRef = (inputColor: string): string => {
  return inputColor || "#284b7d"
}
</script>
